<template>
    <div
        :class="`${isSubItem ? 'iterable-input-subitem' : ''} ${unanswered ? 'unanswered' : ''}`"
    >
        <v-row
            :class="visible ? '': 'hidden'"
        >
            <NumberedItem v-if="item.text"
                :data="modelData"
                :isSubItem="isSubItem"
                :message="item.props && item.props.message"
                :questionWidth="(item.props && item.props.questionWidth) || questionWidth"
                :required="item.props && item.props.required"
                v-bind:count="count"
                v-bind:text="item.text"
            />

            <DynamicInput
                :data="modelData"
                :item="item"
                :questionnaireData="modelData"
                :readonly="readonly"
                :validatingSubmission="validatingSubmission"
                :visible="visible"
                :projectId="projectId"
                :moduleKey="moduleKey"
                :userId="userId"
                :handleTabChange="handleTabChange"
                v-model="modelData[item.name]"
                @unanswered="handleUnansweredChanged"
                :openQuestionnaire="openQuestionnaire"
            />

            <template v-if="isInline">
                <!-- An inline item type will display multiple inputs in a single row -->

                <DynamicInput
                    v-for="(inlineItem) in item.items"
                    :key="inlineItem.id"
                    :data="modelData"
                    :item="inlineItem"
                    :questionnaireData="modelData"
                    :readonly="readonly"
                    :validatingSubmission="validatingSubmission"
                    :visible="inlineItem.visible"
                    :projectId="projectId"
                    :isInline="isInline"
                    :handleTabChange="handleTabChange"
                    v-model="modelData[inlineItem.name]"
                    @unanswered="handleUnansweredChanged"
                    :openQuestionnaire="openQuestionnaire"
                />
            </template>
        </v-row>

        <!-- Now that the main input has rendered, let's render any additional subitems -->
        <!-- Subitems will be indented and will not be numbered -->
        <template
            :class="visible ? '': 'hidden'"
        > 
            <IterableInput
                v-for="(subItem) in item.subItems"
                :isSubItem="true"
                :item="subItem"
                :questionWidth="questionWidth"
                :readonly="readonly"
                :validatingSubmission="validatingSubmission"
                :visible="subItem.visible"
                :projectId="projectId"
                :moduleKey="moduleKey"
                :userId="userId"
                :handleTabChange="handleTabChange"
                :openQuestionnaire="openQuestionnaire"
                class="template-row-item"
                v-bind:key="'section-subitem-' + subItem.id"
                v-model="modelData"
            />
        </template>
    </div>
</template>

<script>
    import DynamicInput from './dynamic-input';
    import NumberedItem from './numbered-item';

    export default {
        name: 'IterableInput',
        components: {
           DynamicInput,
           NumberedItem
        },
        props: {
            count: Number,
            isSubItem: Boolean,
            item: Object,
            questionWidth: String,
            readonly: Boolean,
            subItem: Object,
            validatingSubmission: Boolean,
            value: [String, Number, Object],
            visible: Boolean,
            projectId: String,
            moduleKey: String,
            userId: String,
            handleTabChange: Function,
            openQuestionnaire: Function
        },
        data: function () {
            return {
                isInline: this.item.type === 'inline' && Array.isArray(this.item.items),
                unanswered: false
            };
        },
        computed: {
            modelData: {
                get: function () {
                    return this.value || {};
                },
                set: function (newVal) {
                    this.$emit('input', { ...newVal });
                }
            }
        },
        methods: {
            handleUnansweredChanged: function () {
                const { unanswered, items } = this.item;

                if (this.isInline) {
                    // If this is an inline item, we need to check if any of the subitems are unanswered
                    this.unanswered = items.some(item => item.unanswered);
                } else {
                    this.unanswered = unanswered;
                }
            }
        }
    };
</script>

<style scoped>
    .hidden {
        display: none;
    }

    .template-row-item:hover {
        /* background: rgb(238, 238, 238); */
        background: rgba(237, 229, 204, 0.25);
    }

    .unanswered {
        background: rgba(255, 147, 147, 0.25) !important;
    }
</style>


// WEBPACK FOOTER //
// src/components/questionnaire_template/iterable-input.vue